import { render } from "./main-dev-file.vue?vue&type=template&id=2d40f1b2"
import script from "./main-dev-file.vue?vue&type=script&lang=js"
export * from "./main-dev-file.vue?vue&type=script&lang=js"

import "./main-dev-file.vue?vue&type=style&index=0&id=2d40f1b2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__